var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageBox({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 2.70801C20 1.60801 19.1 0.708008 18 0.708008H2C0.9 0.708008 0 1.60801 0 2.70801V14.708C0 15.808 0.9 16.708 2 16.708H18C19.1 16.708 20 15.808 20 14.708V2.70801ZM18 2.70801L10 7.69801L2 2.70801H18ZM18 14.708H2V4.70801L10 9.70801L18 4.70801V14.708Z",
    fill: "#FF7B6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageBox);
export default __webpack_public_path__ + "static/media/message-box.312246701035e94a7dd69ec5d3c954d7.svg";
export { ForwardRef as ReactComponent };